class MFP {
  constructor(imagesParent, attachToClass, flickityObject, magnifierObject, img_urls) {
    this.imagesParent = imagesParent;
    this.attachToClass = attachToClass;
    this.flickityObject = flickityObject;
    // this.magnifierObject = magnifierObject;
    this.optionsMap = {};
    this.dataReadyCount = 1;
    this.img_urls = img_urls;
  }

  create(){
    this.resetOptionsMap();
    this.attach();
  }

  resetOptionsMap(){
    this.createBaseMap();
    this.createMainMap();
  }

  createBaseMap() {
    var dateReadyCount = 1;
    var self = this;
    this.optionsMap = {
      items: [], 
      gallery: { enabled: true, tNext: '♡ next pic ♡', tPrev: '♡ previous pic ♡' }, 
      type: 'image', index: 0, callbacks: {
        change: function () {
          if(self.flickityObject)self.flickityObject.select(this.index);
        },
        updateStatus: function (data) {
          // alert(data.status);
          // if (data.status === 'ready') {
          //   // alert("data ready " + self.dataReadyCount);
          //   if (self.dataReadyCount === 2) { 
          //     self.magnifierObject.createMagnifier();
          //     self.dataReadyCount = 1; }
          //   else{self.dataReadyCount += 1;}
          //   // self.magnifierObject.createMagnifier();
          // }
// this below
          // self.magnifierObject.createMagnifier();

        },
        close: function (){
          // Do whatever else you need to do here
          // self.magnifierObject.removeWrapper();
        }
      }
    };
  }


  createMainMap() {
    for(let URL of this.img_urls) {
      // alert(URL);
      this.optionsMap.items.push({src: URL, type: 'image'});
      }
  }

  setIndex(index){
    this.optionsMap.index = index;
    this.attach();
  }

  attach() {
    $(this.attachToClass).magnificPopup(this.optionsMap);
  }
}

